import { P as o } from "./ECAPIProductsDTOs-yt2aYenh.js";
import { M as T } from "./ECAPIProductsDTOs-yt2aYenh.js";
function y(i) {
  if (!(typeof i > "u" || i.length === 0))
    return i.map((t) => {
      var r;
      return ((r = t.split("/").pop()) == null ? void 0 : r.trim()) || "";
    });
}
function s(i, t = "|") {
  if (!(typeof i > "u" || i.length === 0))
    return i.map((r) => r.trim()).join(t);
}
function g(i) {
  var t;
  if (!(typeof i > "u" || i.length === 0))
    return i.length === 1 ? n((t = y(i)) == null ? void 0 : t[0]) : "multiple";
}
function n(i) {
  if (!(typeof i > "u"))
    return i.toString().trim();
}
const p = async (i) => window.napi.catalog().getProduct(i), w = async (i, t) => {
  const r = i.map((e) => p(e)), d = await Promise.all(r), _ = {
    event: "view_item_list",
    event_raised_by: t == null ? void 0 : t.eventRaisedBy,
    subscription_product_included: "false",
    // TODO: TBD
    discovery_offer_included: "false",
    // TODO: TBD
    ecommerce: {
      currency: window[window.config.padl.namespace].dataLayer.app.app.currency,
      value: d.reduce((e, m) => e + m.price, 0),
      items: d.map((e, m) => {
        var l, u, f;
        let a = {
          item_id: n(e.internationalId),
          item_name: n(e.internationalName),
          item_brand: "nespresso",
          item_category: n(e.type),
          item_category2: s(
            y(e.technologies)
          ),
          item_category3: n(e.category),
          price: e.price,
          quantity: e.salesMultiple,
          affiliation: "nespresso online store",
          coupon: void 0,
          discount: void 0,
          location_id: void 0,
          item_list_name: n(t == null ? void 0 : t.listName),
          //TODO: check with Analytics
          item_list_id: n(t == null ? void 0 : t.listId),
          index: m + 1,
          item_market_id: n(e.legacyId),
          item_market_name: n(e.name),
          item_technology: g(e.technologies),
          item_range: n(e.category),
          item_discovery_offer: e.category.includes("discovery").toString(),
          item_added_by_user: void 0,
          item_ecotax_applicable: n(
            e.displayEcoTax.toString()
          ),
          item_selection_list: n(
            s(e.productSelections)
          ),
          item_in_stock: e.inStock.toString(),
          item_subscription_name: void 0,
          //string, fill this with the nessoft "id" field in the subscription information
          item_subscription_category: void 0,
          //string, fill this with the nessoft "type" field in the subscription information
          item_subscription_price: void 0,
          //metric, fill this with the nessoft "promotionalPrice" field in the subscription information
          item_subscription_duration: void 0,
          //string, fill this with the nessoft "monthsDuration" field in the subscription information
          item_subscription_fee: void 0
          //string, fill this with the nessoft "periodicFee" field in the subscription information
        };
        switch (e.type) {
          case o.Capsule: {
            const c = e;
            a.item_category4 = c.bundled ? "bundle" : "single", a.item_type = c.bundled ? "bundle" : "single", a.item_coffee_aromatic_profile = n(
              (l = s(
                c.capsuleProductAromatics
              )) == null ? void 0 : l.toLowerCase()
            ), a.item_coffee_intensity = n(
              c.capsuleProperties.intensity
            ) ?? void 0, a.item_coffee_cup_size = (u = n(
              s(c.capsuleCupSizes)
            )) == null ? void 0 : u.toLowerCase();
            break;
          }
          case o.Machine: {
            const c = e;
            a.item_machine_shade = n(
              (f = c.colorShade) == null ? void 0 : f.name
            );
            break;
          }
        }
        return (o.Machine || o.Accessory) && (a.item_avg_rating = e.ratingCode, a.item_number_of_reviews = e.ratingCode), a;
      })
    }
  };
  (t == null ? void 0 : t.eventRaisedBy) === void 0 && delete _.event_raised_by, window.gtmDataObject.push({ ecommerce: null }), window.gtmDataObject.push(_);
}, b = async (i) => {
  const t = window.padl.app.currency;
  return (await window.napi.priceFormat()).short(t, i);
};
export {
  T as MediaTypeDTO,
  o as ProductTypeDTO,
  b as formatPrice,
  p as getProduct,
  w as viewItemList
};
